import React from 'react';
import { CtaButton } from './CtaButton';
import { lifestyleImage } from '../../data/presellContent';
export function FinalCta() {
  return <section id="cta" className="w-full bg-white" data-id="element-22" data-mp="2ix8rdzh84oq9">
      <div className="max-w-4xl mx-auto px-5 md:px-8 py-16 md:py-20" data-id="element-23" data-mp="2dyyu9jbxve20">
        <img src={lifestyleImage} alt="A couple in their sixties doing gentle stretching exercises together on the beach at sunset" className="w-full h-[220px] md:h-[340px] object-cover rounded-2xl" loading="lazy" data-id="element-24" data-mp="2dx47s0l0rdvt" />

        <div className="mt-10 md:mt-12 text-center max-w-2xl mx-auto" data-id="element-25" data-mp="31pkrsgobhfxr">
          <h2 className="text-2xl md:text-4xl font-bold text-[#22322C] leading-snug" data-id="element-26" data-mp="2xmoe94dmwa0o">
            Ready To Learn How Joint Genesis Works?
          </h2>

          <p className="mt-6 text-lg md:text-xl text-[#4A5D50] leading-relaxed" data-id="element-27" data-mp="2sqhb1jcmhcmf">
            Watch the full presentation to discover how the formula works, what's
            inside it, and why so many people are interested in this new
            approach.
          </p>

          <div className="mt-10 flex flex-col items-center" data-id="element-28" data-mp="1lygemhax6mz9">
            <CtaButton size="large" data-id="element-29" data-mp="1qxjja0mzmr6p" />
          </div>
        </div>
      </div>
    </section>;
}